<template>
  <div class="container_prop">
    <v-row
      align="center"
      justify="center"
      class="flex-column-reverse flex-md-row"
    >
      <!-- Conteúdo à direita -->
      <v-col cols="12" md="6" class="px-6">
        <div class="video-text">
          <h2 class="headline text-black">INOVAÇÃO É O NOSSO DNA!</h2>
          <p class="subtitle text-black">
            Estamos projetando um centro de pesquisas e desenvolvimento de 500m²
            para abrigar dezenas de engenheiros, cientistas e pesquisadores, que
            irão liderar projetos em materiais, hardware, automação para
            geometrias complexas e processos de manufatura aditiva avançada
            (como tecnologias de impressão metálica acessível). O resultado
            desse esforço será o avanço das técnicas e capacidades de produção
            do mercado nacional, a diminuição da dependência de importações e a
            viabilidade de uma produção local com acabamento industrial. Estamos
            fazendo tudo isso para atender você ainda melhor, e sempre com
            produtos feitos localmente aqui no Brasil! Saiba mais sobre nossas
            pesquisas científicas em andamento e pesquisas futuras clicando em:
          </p>
          <v-btn
            href="https://lab.makermarket.com/"
            target="_blank"
            color="black"
            variant="outlined"
            class="mt-1"
          >
            M.A.K.E.R. LAB
          </v-btn>
        </div>
      </v-col>

      <!-- Vídeo à esquerda -->
      <v-col cols="12" md="6" class="px-6">
        <video autoplay muted loop playsinline class="home-video">
          <source src="@/assets/home-video1.mp4" type="video/mp4" />
          Seu navegador não suporta o vídeo.
        </video>
      </v-col>

      <!-- Vídeo à esquerda -->
      <v-col cols="12" md="6" class="px-6 mt-6">
        <video autoplay muted loop playsinline class="home-video">
          <source src="@/assets/home-video2.mp4" type="video/mp4" />
          Seu navegador não suporta o vídeo.
        </video>
      </v-col>
      <v-col cols="12" md="6" class="px-6 mt-6">
        <div class="video-text">
          <h2 class="headline text-black">
            TRANSFORMAMOS SONHOS EM REALIDADE!
          </h2>
          <p class="subtitle text-black">
            Graças ao trabalho em conjunto da nossa comunidade de Makers,
            Designers e Lojistas, você pode focar naquilo em que é expert, e não
            precisa se preocupar com o resto! O Lojista foca em vender, divulgar
            sua loja e em dar o melhor atendimento possível. O Maker foca em
            fazer impressões com cada vez mais qualidade e agilidade para enviar
            aos compradores. O Designer pode aperfeiçoar ainda mais suas
            técnicas criativas de modelagem 3D. Trabalhando juntos, tudo é
            possível!
          </p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "VideoHome",
};
</script>

<style lang="css" scoped>
@media (max-width: 537px) {
  .container_prop {
    max-width: 95vw !important;
  }
}

.container_prop {
  max-width: 80vw;
  margin: 20px auto 60px auto;
}
/** Video section */
.video-section {
  padding: 96px 16px;
}

.home-video {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1);
  object-fit: cover;
}

.headline {
  word-wrap: break-word;
}

.video-text {
  text-align: left;
  max-width: 500px;
  margin: 0 auto;
}

.video-text .headline {
  font-size: 36px;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 16px;
  text-transform: uppercase;
}

.video-text .subtitle {
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 24px;
}

.v-theme--dark .subtitle {
  color: #f5f5f5;
}
</style>
